// eslint-disable-next-line
export const setFilters = {
  methods: {
    setFilters(filters) {
      let filtersAll = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          const filter = { [key]: value };
          filtersAll = Object.assign(filtersAll, filter);
        }
      });
      if (Object.keys(filtersAll).length) {
        const queryUrl = [];
        Object.entries(filtersAll).forEach(([key, value]) => {
          queryUrl.push(`${key}=${encodeURIComponent(value)}`);
        });
        if (`${this.$route.path}?${queryUrl.join('&')}` === this.$route.fullPath) {
          return;
        }
        this.$router.push({
          to: this.$route.name,
          query: {
            ...filtersAll,
          },
        });
      } else if (Object.values(this.$route.query).length) {
        this.$router.push({
          to: this.$route.name,
        });
      }
    },
    setFiltersExact(path, filters) {
      let filtersAll = {};
      Object.entries(filters).forEach(([key, value]) => {
        if (value) {
          const filter = { [key]: value };
          filtersAll = Object.assign(filtersAll, filter);
        }
      });
      const queryUrl = [];
      Object.entries(filtersAll).forEach(([key, value]) => {
        queryUrl.push(`${key}=${encodeURIComponent(value)}`);
      });
      return `${path}?${queryUrl.join('&')}`;
    },
  },
};
